import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function useSetChartData(name) {
  const setData = Recoil.useSetRecoilState(AppStore.assets.data(name));
  return setData;
}
